import { FaPlay } from "react-icons/fa";
import { HiOutlineCheck } from "react-icons/hi2";
import { RxLockClosed } from "react-icons/rx";
import { secondsToTime } from "../../../../utils/helpers";

function Item({ itemDetail }) {
    const {
        attributes: { name, brief, type },
        myViews,
        isLocked,
        videoDuration: videoDurationInSeconds,
        attemptCount,
    } = itemDetail;

    return (
        <div className="flex w-full gap-5 pt-2">
            <div className="flex items-center justify-center ">
                {isLocked ? (
                    <RxLockClosed className="text-3xl font-bold text-gray-color-primary" />
                ) : myViews > 0 || attemptCount ? (
                    <span className="p-2 rounded-full bg-secondary-color">
                        <HiOutlineCheck className="text-2xl font-bold text-white" />
                    </span>
                ) : (
                    <span className="block w-10 h-10 border-2 border-dashed rounded-full border-gray-color-primary"></span>
                )}
            </div>
            <div className="flex flex-col gap-2 w-fit">
                <p className="font-normal text-gray-color-primary">{name}</p>
                <h4 className="font-medium text-blue-color-primary">{brief}</h4>
                <span className="flex items-center gap-2 font-normal text-gray-color-primary">
                    {type === "video" && (
                        <>
                            <span className="mt-1">
                                {secondsToTime(videoDurationInSeconds)}
                            </span>
                            <FaPlay />
                        </>
                    )}
                </span>
            </div>
        </div>
    );
}

export default Item;
